import { Slot } from '@radix-ui/react-slot'
import type { HTMLAttributes } from 'react'
import { tv, type VariantProps } from 'tailwind-variants'

const statusBadge = tv({
  base: 'rounded-[4px] border px-4 font-semibold',
  variants: {
    variant: {
      pending:
        'border-alert-warning bg-alert-warning/10 text-alert-warning text-sm md:text-base',
      approved:
        'border-alert-success bg-alert-success/10 text-alert-success text-sm md:text-base',
      rejected:
        'border-alert-danger bg-alert-danger/10 text-alert-danger text-sm md:text-base',
    },
  },
  defaultVariants: {
    variant: 'pending',
  },
})

export interface StatusBadgeProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof statusBadge> {
  asChild?: boolean
  status?: 1 | 2 | 3 | 'P' | 'A' | 'R'
}

export function StatusBadge({
  asChild,
  variant,
  status,
  className,
  children,
  ...props
}: StatusBadgeProps) {
  const Component = asChild ? Slot : 'div'

  const statusToVariant = {
    1: 'pending',
    2: 'approved',
    3: 'rejected',
    P: 'pending',
    A: 'approved',
    R: 'rejected',
  } as const

  const statusToText = {
    1: 'Pendente',
    2: 'Aprovado',
    3: 'Reprovado',
    P: 'Pendente',
    A: 'Aprovado',
    R: 'Reprovado',
  } as const

  const finalVariant = status ? statusToVariant[status] : variant
  const displayText = status ? statusToText[status] : children

  return (
    <Component
      {...props}
      className={statusBadge({ variant: finalVariant, className })}
    >
      {displayText}
    </Component>
  )
}
